import React from 'react'
import ReadOnlyDetailsCard from '../../../../ui/ReadOnlyDetailsCard/ReadOnlyDetailsCard'
import ActiveStatusBadge from '../../../../ui/ActiveStatusBadge/ActiveStatusBadge'
import { formatDateAsDayMontYearHHMM } from '../../../../utils/date/dateFormat'
import {
  INDEXATION_MODE_CHIP_VARIANT,
  INDEXATION_MODE_OPTIONS,
  REVIEW_STATUS_CHIP_VARIANT,
  REVIEW_STATUS_OPTIONS,
  getSeoOptionLabel,
} from '../../seo'
import { NODE_TYPE } from './catalogTaxonomyConstants'
import styles from './CatalogTaxonomySystemDataCard.module.scss'

const TYPE_LABELS = {
  [NODE_TYPE.GLOBAL]: 'Глобальна категорія',
  [NODE_TYPE.CATEGORY]: 'Категорія',
  [NODE_TYPE.SUBCATEGORY]: 'Підкатегорія',
}

function formatTimestamp(value) {
  if (!value) return '—'

  let seconds = null
  if (typeof value.seconds === 'number') {
    seconds = value.seconds
  } else if (typeof value.toDate === 'function') {
    seconds = Math.floor(value.toDate().getTime() / 1000)
  } else if (value instanceof Date) {
    seconds = Math.floor(value.getTime() / 1000)
  }

  if (seconds == null) return '—'
  return formatDateAsDayMontYearHHMM({ seconds })
}

function StatusChip({ value, options, variantMap }) {
  const variant = variantMap[value] || 'neutral'
  return (
    <span className={[styles.chip, styles[`chip_${variant}`]].filter(Boolean).join(' ')}>
      {getSeoOptionLabel(options, value)}
    </span>
  )
}

function CatalogTaxonomySystemDataCard({ node, seoForm }) {
  if (!node) return null

  const reviewStatus = seoForm?.reviewStatus?.value ?? node.seo?.reviewStatus
  const indexationMode = seoForm?.indexationMode?.value ?? node.seo?.indexationMode

  return (
    <div className={styles.wrap}>
      <ReadOnlyDetailsCard
        title="Системні дані"
        rows={[
          { label: 'Тип', value: TYPE_LABELS[node.type] || node.type || '—' },
          { label: 'Назва', value: node.name || '—' },
          { label: 'Slug', value: node.slug || '—', mono: true },
          {
            label: 'Активність',
            value: <ActiveStatusBadge isActive={node.isActive === true} />,
          },
          {
            label: 'У навігації',
            value:
              node.showInNavigation === true ? (
                <span className={[styles.chip, styles.chip_success].join(' ')}>Так</span>
              ) : (
                <span className={[styles.chip, styles.chip_neutral].join(' ')}>Ні</span>
              ),
          },
          {
            label: 'Архів',
            value:
              node.isArchived === true ? (
                <span className={[styles.chip, styles.chip_neutral].join(' ')}>Так</span>
              ) : (
                <span className={[styles.chip, styles.chip_neutral].join(' ')}>Ні</span>
              ),
          },
          { label: 'Порядок', value: node.sortOrder ?? '—' },
          { label: 'Firestore ID', value: node.id || '—', mono: true },
          { label: 'Оновлено', value: formatTimestamp(node.updatedAt) },
          {
            label: 'Статус SEO-перевірки',
            value: (
              <StatusChip
                value={reviewStatus}
                options={REVIEW_STATUS_OPTIONS}
                variantMap={REVIEW_STATUS_CHIP_VARIANT}
              />
            ),
          },
          {
            label: 'SEO індексація',
            value: (
              <StatusChip
                value={indexationMode}
                options={INDEXATION_MODE_OPTIONS}
                variantMap={INDEXATION_MODE_CHIP_VARIANT}
              />
            ),
          },
        ]}
      />
    </div>
  )
}

export default CatalogTaxonomySystemDataCard
